import { useQuery } from '@tanstack/react-query';

import { type InParkingCardDetail } from 'src/features/cards/types/card';
import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';

import type { GeneralSmartParkError, ListDTO } from 'src/types';

interface Query extends ListDTO {
    parkingId: string;
}

interface InParkingCardDetailsQuery extends Query {
    id: number;
}

export const getInParkingCard = ({ parkingId, id }: InParkingCardDetailsQuery): Promise<InParkingCardDetail | null> => {
    return axios.get(`/parkings/${parkingId}/cards/in-parking/${id}/`);
};

type InParkingCardQueryFnType = typeof getInParkingCard;
type UseInParkingCardOptions = {
    parkingId: string;
    id?: number;
    config?: QueryConfig<InParkingCardQueryFnType, GeneralSmartParkError>;
};

export const useGetInParkingCard = ({ parkingId, id, config }: UseInParkingCardOptions) =>
    useQuery({
        queryKey: ['inParkingCard', parkingId, id],
        queryFn: async () => {
            if (!id || !parkingId) return null;
            return await getInParkingCard({ parkingId, id });
        },
        enabled: !!parkingId && !!id,
        ...config,
    });
